<template>
  <span
    class="d-text-with-links"
  >
    <span
      v-for="(processedContentPart, idx) in processedContentParts"
      :key="idx"
    >
      <span
        v-if="processedContentPart.type === partTypes.text"
        :class="{ 'multiline': displayMultiline }"
      >{{ processedContentPart.text }}</span>

      <a
        v-if="processedContentPart.type === partTypes.link"
        :href="processedContentPart.url"
        rel="nofollow"
        target="_blank"
        :title="processedContentPart.url"
        @click.stop
      >{{ processedContentPart.url }}</a>

      <DUserLinkPopup
        v-if="processedContentPart.type === partTypes.mention"
        :user-id="processedContentPart.mention.id"
      >
        <template slot="content">
          <a
            :href="processedContentPart.mention.url"
            target="_blank"
            @click.stop
          >@{{ processedContentPart.mention.username }}</a>
        </template>
      </DUserLinkPopup>
    </span>
  </span>
</template>

<script>
import DUserLinkPopup from '../d-user-link-popup/d-user-link-popup.vue';
import MentionsHelper from '@d-helpers/mentions-helper';

export const PART_TYPES = Object.freeze({
  text: 0,
  link: 1,
  mention: 2,
});

// https://www.regextester.com/96249
// https://stackoverflow.com/questions/1500260/detect-urls-in-text-with-javascript
const URL_REGEX = /(https?:\/\/[^\s]+)/gi;

function _getBasicProcessedContent(content) {
  return [
    {
      text: content,
      type: PART_TYPES.text,
    },
  ];
}

function _getProcessedContentWithMentions(contentParts, mentions) {
  mentions.forEach((mention) => {
    // TODO: Need to be check after merge https://github.com/reedsy/reedsy-discovery/pull/975
    const mentionPlaceholder = MentionsHelper.getMentionPlaceholder(mention.id);

    let newProcessedContents = [];

    contentParts.forEach((part) => {
      // If it's not text, it's already been processed
      if (part.type !== PART_TYPES.text) {
        newProcessedContents.push(part);
        return;
      }

      const splitContents = part.text.split(mentionPlaceholder);
      const splitContentsMaxIdx = (splitContents.length - 1);

      splitContents.forEach((splitContent, idx) => {
        newProcessedContents.push({
          text: splitContent,
          type: PART_TYPES.text,
        });

        if (idx === splitContentsMaxIdx) {
          return;
        }

        newProcessedContents.push({
          mention: mention,
          type: PART_TYPES.mention,
        });
      });
    });

    contentParts = newProcessedContents;
  });

  return contentParts;
}

function _getProcessedContentWithUrls(textContent) {
  let processedContentParts = [];

  const urlSplitParts = textContent.split(URL_REGEX);
  urlSplitParts.forEach((part) => {
    if (URL_REGEX.test(part)) {
      processedContentParts.push({
        type: PART_TYPES.link,
        url: part,
      });
      return;
    }

    processedContentParts.push({
      text: part,
      type: PART_TYPES.text,
    });
  });

  return processedContentParts;
}

export default {
  components: {
    DUserLinkPopup,
  },
  props: {
    content: {
      type: String,
      default: null,
    },
    displayMultiline: {
      type: Boolean,
      default: false,
    },
    displayTypedLinks: {
      type: Boolean,
      default: false,
    },
    mentions: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    partTypes: PART_TYPES,
    processedContentParts: [],
  }),
  watch: {
    content: function() {
      this.configureContent();
    },
  },
  mounted() {
    this.configureContent();
  },
  methods: {
    configureContent() {
      if (!this.content) {
        return;
      }

      let processedContentParts = this.displayTypedLinks ?
        _getProcessedContentWithUrls(this.content) :
        _getBasicProcessedContent(this.content);

      if (!this.mentions) {
        this.$set(this, 'processedContentParts', processedContentParts);
        return;
      }

      processedContentParts = _getProcessedContentWithMentions(processedContentParts, this.mentions);
      this.$set(this, 'processedContentParts', processedContentParts);
    },
  },
};
</script>

<style lang="scss" scoped>
.d-text-with-links {
  word-break: break-word;

  .multiline {
    white-space: pre-line;
  }
}
</style>
